/* eslint-disable */
import fpti from '@paypalcorp/fpti'
import { application, hostname } from '../constants'
import { getPgrp } from './get-pgrp'

const SANDBOX_API_CALLS = 'Sandbox API Calls'
const LIVE_API_CALLS = 'Live API Calls'
const NAVIGATION_PREVIOUS_API_CALLS = 'previous page'
const NAVIGATION_NEXT_API_CALLS = 'next page'
const SANDBOX_WEBHOOKS_EVENTS = 'Sandbox Webhooks Events'
const LIVE_WEBHOOKS_EVENTS = 'Live Webhooks Events'
const PAGINATION_WEBHOOKS_EVENTS = 'pagination click'
const NAVIGATION_PREVIOUS_WEBHOOKS_EVENTS = 'previousPage'
const NAVIGATION_NEXT_WEBHOOKS_EVENTS = 'nextPage'

/**
 * returns the eventCategory, eventAction, eventLabel, and link (optional) in object format.
 * returns null if the event does not need to be tracked.
 * @param {Array} trackingData [ec, ea, el, link?]
 * @param {Array} path path to the page
 * @param {String} pgrp page group
 */
function getTrackingDataObj(trackingData, path, pgrp) {
  let eventCategory = trackingData[0].trim()
  let eventAction = trackingData[1].trim()
  let eventLabel = trackingData[2].trim()
  let link
  if (trackingData.length >= 4) link = trackingData[3].trim()

  // EXCEPTION 1: DashboardTable data-dxa values for SB/Live API Calls page
  const pgrpArray = pgrp.split(':')
  if (pgrpArray[pgrpArray.length - 1].trim() === 'dashboard') {
    // default ec is generic
    if (path[path.length - 1] === 'sandbox') eventCategory = SANDBOX_API_CALLS
    else if (path[path.length - 1] === 'live') eventCategory = LIVE_API_CALLS

    // default navigation actions are reversed
    if (eventLabel === 'next page') eventLabel = NAVIGATION_PREVIOUS_API_CALLS
    else if (eventLabel === 'previous page')
      eventLabel = NAVIGATION_NEXT_API_CALLS
  }

  // EXCEPTION 2: DashboardTable data-dxa values for SB/Live Webhooks Events page
  else if (pgrpArray[pgrpArray.length - 1].trim() === 'webhooks') {
    // default ec is generic
    if (path[path.length - 1] === 'sandbox')
      eventCategory = SANDBOX_WEBHOOKS_EVENTS
    else if (path[path.length - 1] === 'live')
      eventCategory = LIVE_WEBHOOKS_EVENTS

    // default navigation actions are wrong
    if (eventAction === 'page click') eventAction = PAGINATION_WEBHOOKS_EVENTS
    if (eventLabel === 'next page')
      eventLabel = NAVIGATION_PREVIOUS_WEBHOOKS_EVENTS
    else if (eventLabel === 'previous page')
      eventLabel = NAVIGATION_NEXT_WEBHOOKS_EVENTS
  }

  // EXCEPTION 3: unwanted events
  else {
    // search events not occuring in API Calls or Webhooks Events
    if (eventAction === 'search') return null
  }

  return { eventCategory, eventAction, eventLabel, link }
}

/**
 * Records events for FPTI and GA.
 * @param {HTMLElement} el the element that was clicked
 * @param {Object} fptiData FPTI data to track
 */
export function recordFptiAndGaEvent(
  el,
  fptiData,
  trackingData,
  dynamicFPTIData,
) {
  const options = { ...fptiData } || {}

  // differentiate between ddnw and dnw
  const pathList = window.location.pathname.replace(/(^\/|\/$)/g, '').split('/')
  const component =
    pathList.length > 1 && pathList[0] === 'dashboard'
      ? 'devdashnodeweb'
      : 'devdiscoverynodeweb'

  // ddnw configurations
  const path = getPgrp(pathList)
  const pgrp =
    path[path.length - 1] === 'sandbox' || path[path.length - 1] === 'live'
      ? path.slice(0, -1).join(':')
      : path.join(':')
  const page = path.join(':')

  // set tracking event data
  if (trackingData && trackingData.includes(',')) {
    trackingData = trackingData.split(',')
  }
  options.user_type = dynamicFPTIData.secondaryUser ? 'secondary' : 'primary'
  if (dynamicFPTIData.env_name) options.env_name = dynamicFPTIData.env_name
  if (trackingData && trackingData.length && trackingData.length >= 3) {
    const trackingDataObj = getTrackingDataObj(trackingData, path, pgrp)
    if (trackingDataObj) {
      // modify FPTI data
      options.pgrp = pgrp
      options.page = page
      options.comp = component
      options.env = application.env
      options.e = 'cl'
      options.event_category = trackingDataObj.eventCategory
      options.event_action = trackingDataObj.eventAction
      options.event_label = trackingDataObj.eventLabel
      if (trackingDataObj.eventLabel.includes('sandbox')) {
        options.toggle_environment = 'sandbox'
      } else if (trackingDataObj.eventLabel.includes('live')) {
        options.toggle_environment = 'live'
      }
      if (trackingDataObj.env_name) options.env_name = trackingDataObj.env_name
      if (trackingDataObj.link) options.link = trackingDataObj.link

      const nullProperties = ['cd', 'sw', 'sh', 'dw', 'dh', 'bw', 'bh', 'ce']
      nullProperties.forEach((key) => (options[key] = null))

      // record FPTI click
      fpti.record(options)

      // record GA click
      if (window.ga) {
        window.ga('send', 'event', {
          eventCategory: trackingDataObj.eventCategory,
          eventAction: trackingDataObj.eventAction,
          eventLabel: trackingDataObj.eventLabel,
          eventValue: trackingDataObj.link,
        })
      }
    }
  }
}
